import script from "./DiamondCertificateChecker.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiamondCertificateChecker.vue?vue&type=script&lang=ts&setup=true"

import "./DiamondCertificateChecker.vue?vue&type=style&index=0&id=73ae488e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73ae488e"]])

export default __exports__